<div class="details-container">

  <div class="details-header" style="background: url(assets/images/fsce1.jpg);">
      
    <div class="details-banner">
        <h1>Future Stories Community Enterprise (FSCE)</h1>
        <h2>11 Plus (11+) Exam Information</h2>
    </div>
</div>


<div class="details-publisher">
  <span><strong>Published by - SEHYOG Academy</strong></span>
</div>

<div class="details-content">

  <div class="details-section">

    <h3>Introduction</h3>

    <div class="spacer"></div>

    <p>Future Stories Community Enterprise Ltd (FSCE) is a non-profit organisation focused on providing children with tailored education and support to help them achieve their full potential. FSCE offers a wide range of services, including support for the 11+ exam, as well as outreach programmes designed to ensure that children from all backgrounds have the opportunity to excel academically. <br> <br>


      The organisation strives to make a lasting impact on the lives of children and their families, equipping them with the necessary skills to succeed in their educational journey. <br> <br>
      
      
      FSCE also acts as an exam board and offers a unique exam format for students taking the 11+ exam in the United Kingdom. </p>

    <div class="spacer"></div>

    <p>FSCE is a relatively new entrant in this field. Currently, its exam is used by the following schools:</p>

    <div><img src="assets/images/check-list.png" alt=""> <p>Chelmsford County High School</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Colyton Grammar School</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Crossley Heath Grammar School</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Heckmondwike Grammar School</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Reading School for Boys</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>The Blue Coat School</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>The North Halifax Grammar School</p></div>

    
    <div class="spacer"></div>

    <div class="spacer"></div>

    <h4>FSCE’s Partnership with Reading School</h4>

    <p>Reading School is a prestigious grammar school with a strong academic reputation, renowned for its commitment to nurturing talent and fostering a culture of learning. The partnership between FSCE and Reading School enables both organisations to pool their resources and expertise, providing high-quality support for students preparing for the 11+ exam. <br>


      FSCE and Reading School facilitate several outreach initiatives aimed at widening access to high-quality education for children from all backgrounds: <br> <br></p>



      <p>FSCE and Reading School facilitate several outreach initiatives aimed at widening access to high-quality education for children from all backgrounds:</p>


      <p>1. Saturday School: This programme offers free tuition for children from disadvantaged backgrounds, ensuring they have access to the same level of support as their more privileged peers. <br> <br>

        2. Summer School: FSCE’s Summer School programme, supported by Reading School, offers intensive tuition and support to help students prepare for their 11+ exam, covering key areas such as English, Mathematics, Verbal Reasoning, and Non-Verbal Reasoning. <br> <br>

        3. Workshops and seminars: The partnership enables FSCE to organise workshops and seminars for parents and students, providing information about the 11+ exam and insights into the admission processes and requirements at Reading School.</p>

    
    <div class="spacer"></div>

    <div class="spacer"></div>

<h2>Future Stories Community Enterprise (FSCE) 11 Plus (11+) Exam Format</h2>

    <p>The Future Stories exam is designed to test a range of skills and abilities that are essential for success in secondary school and beyond. The exam is also designed to be accessible to all students, regardless of their background or previous educational experience.</p>

    <div class="spacer"></div>

    <p>The FSCE 11 Plus exam comprises three sections:</p>


    <div class="spacer"></div>

    <div><img src="assets/images/check-list.png" alt=""> <p><strong>Paper 1:</strong> mathematics and English skills (multiple-choice format; 45 minutes in length)</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p><strong>Paper 2:</strong> mathematics and English (constrained/free response format; 35 minutes in length)</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Creative Writing (20 minutes in length)    </p></div>

    <div class="spacer"></div>

    <p>Children are expected to show competence in skills appropriate to Key Stage 2 English and Mathematics.</p>

    <div class="spacer"></div>

    <p>The test elements are marked by a computer and are age-standardised to ensure fairness. All students with an eligible score from Papers 1 and 2 will have their creative writing element assessed, which will determine their ranking.</p>

    <div class="spacer"></div>
    <div class="spacer"></div>


    <h2>Which schools use the FSCE 11 Plus (11+) Exam?</h2>

    <p>FSCE creates the 11+ exam for the following grammar schools so far: Chelmsford County High School, Colyton Grammar School, Crossley Heath Grammar School, Heckmondwike Grammar School, Reading School, The Blue Coat School, and The North Halifax Grammar School.</p>

    
</div>

</div>